import React, {FC} from 'react';
import './SectionTitle.scss';
import {preventOrphans} from '../../helpers';

type Props = {
    mainHeading?: boolean
    title: string,
    subTitle?: string;
    description?: string
}


  

const SectionTitle: FC<Props> = ({mainHeading,subTitle, title, description}) => {
    const processedDescription = description ? preventOrphans(description) : '';
    const processedTitle = title ? preventOrphans(title) : '';
    return (
        <div className='section-title'>
            {subTitle && <span>{subTitle}</span>}
            {mainHeading ? <h1>{processedTitle}</h1> : <h2>{processedTitle}</h2>}
            {description && <p>{processedDescription}</p>}
        </div>
    );
};

export default SectionTitle;